import { useEffect, useState } from 'react';
import 'keen-slider/keen-slider.min.css';

/* COMPONENTS */
import Image from '@/components/ui/Image/Image';

/* UTILS */
import { cn } from '@/lib/utils.ts';
import { useKeenSlider } from 'keen-slider/react';

/* COMPONENT PROPS */
interface DesktopCarouselProps {
  images: string[];
}

const DesktopCarousel = (props: DesktopCarouselProps) => {
  const { images } = props;
  const [actualSlide, setActualSlide] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Fonction to change the slide
  const handleSwitch = (index: number) => {
    if (instanceRef.current) {
      setActualSlide(index);
      instanceRef.current?.moveToIdx(index);
    }
  }

  const [sliderRef, instanceRef] = useKeenSlider({
    slides: {
      perView: 1,
      spacing: 0,
      origin: 'center',
    },
  });

  return (
    <div className={cn('h-[calc(100vh-18rem)] flex flex-row')}>
      {/* Images preview on the left */}
      <div
        className={cn(
          'flex flex-col justify-center gap-6 mx-8 h-[calc(100vh-10rem)] overflow-y-auto scrollbar-hide p-1 w-[calc(10vw)]'
        )}
      >
        {images?.map((image, index) => (
          <Image
            key={index}
            src={image}
            alt={`Product image ${index + 1}`}
            className={cn('h-[100px] w-20 object-cover cursor-pointer', {
              'ring-1 ring-[#D8D8DA]': actualSlide === index,
              'opacity-100': actualSlide === index,
              'opacity-20': actualSlide !== index,
            })}
            onClick={() => handleSwitch(index)}
          />
        ))}
      </div>
      {/* Carousel */}
      <div className={cn('flex-1 w-[calc(55vw)] py-8')}>
        {mounted && <div ref={sliderRef} className="keen-slider">
          {images.map((image, index) => (
            <div className="keen-slider__slide" key={index}>
              <Image
                src={image}
                alt={`Product image ${index + 1}`}
                className={cn(
                  'h-[calc(100vh-18rem)] w-full object-contain'
                )}
              />
            </div>
          ))}
        </div>}
      </div>
    </div>
  );
};

export default DesktopCarousel;
